<template lang="pug">
    .z-tool-menu
        .action(ref="action")
            slot(name="action")
        .content(v-bind:class="{'active': $props.active}" ref="content")
            .trine(ref="trine")
            slot
</template>
<script>
    export default {
        name: 'z-tool-menu',
        components: {},
        props: {
            active: {
                type: Boolean,
                default: false
            },
            center: {
                type: Boolean,
                default: true
            },
            left: {
                type: Boolean,
                default: false
            },
            right: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {}
        },
        created() {
            this.$nextTick(() => {
                this.calc();
            });
        },
        watch: {
            '$props.active'(active) {
                if (active) this.calc();
            }
        },
        computed: {},
        methods: {
            calc() {
                if (!this.$refs.content || !this.$refs.action) return;
                let action  = this.$refs.action.getBoundingClientRect();
                let content = this.$refs.content.getBoundingClientRect();
                let trine   = this.$refs.trine.getBoundingClientRect();

                this.$refs.content.style.top = (action.height + 4) + 'px';

                if (this.$props.center) {
                    this.$refs.content.style.left = -(content.width / 2 - (action.width/2)) + 'px';
                    this.$refs.trine.style.left   = (content.width / 2 - (trine.width/2)) + 'px';
                }
                if (this.$props.left) {
                    this.$refs.content.style.left = '0px';
                    this.$refs.trine.style.left   = (action.width/2) + 'px';
                }
                else if (this.$props.right) {
                    this.$refs.content.style.right = '0px';
                    this.$refs.trine.style.right   = (action.width/2) + 'px';
                    this.$refs.content.style.left = 'auto';
                    this.$refs.trine.style.left   = 'auto';
                }
            }
        }
    }
</script>
<style lang="sass">
    .z-tool-menu
        display: flex
        align-items: center
        justify-content: flex-start
        position: relative
        .content
            position: absolute
            background: #FFFFFF
            box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2)
            border-radius: 3px
            padding: 5px
            width: auto
            z-index: 16
            left: 0
            top: 0px
            visibility: hidden
            .trine
                width: 5.6px
                height: 5.6px
                border-top: 2.8px
                border-left: 2.8px
                transform: rotate(45deg)
                position: absolute
                display: block
                top: -3px
                left: 0
                right: 0
                background: #fff
                box-shadow: -2px -2px 4px 0px rgba(0, 0, 0, 0.1)
            &.active
                opacity: 1
                visibility: visible
</style>


// WEBPACK FOOTER //
// ZToolMenu.vue?6cca2fa2